/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_IntroInputs */

const en_ai_intro = /** @type {(inputs: Ai_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Used to read transcripts, write recipes and match ingredients. Your keys stay on your server, encrypted.`)
};

const de_ai_intro = /** @type {(inputs: Ai_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liest Transkripte, schreibt Rezepte und ordnet Zutaten zu. Deine Schlüssel bleiben verschlüsselt auf deinem Server.`)
};

/**
* | output |
* | --- |
* | "Used to read transcripts, write recipes and match ingredients. Your keys stay on your server, encrypted." |
*
* @param {Ai_IntroInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_intro = /** @type {((inputs?: Ai_IntroInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_IntroInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_intro(inputs)
	return en_ai_intro(inputs)
});